import { IconButton } from '@app/components/core/button/IconButton'
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons'

export const EditButton = ({
  isVisible = true,
  onClick,
}: {
  isVisible?: boolean
  onClick: VoidFunction
}) => {
  if (!isVisible) {
    return null
  }
  return (
    <IconButton
      size="small"
      variant="secondary"
      icon={faPenToSquare}
      onClick={onClick}
    />
  )
}
